// 废弃
<template>
  <Table :columns="tableParam.columns" :data="tableParam.data" :show-header="tableParam.header" :size="tableParam.size">
    <template slot-scope="{ row }" slot="bankName">
      <div class="df">
        <span class="mr3 wh20 dl" :style="logoStyle(row.bankIcon)"></span>
        <div>
          <div class="c333 f13">{{row.bankName}}</div>
          <div class="c999 f12">贴入行</div>
        </div>
      </div>
    </template>
    <template slot-scope="{ row }" slot="bankType">
      <div class="c333 f13">{{ row.bankType }}</div>
      <div class="c999 f12">承兑人分类</div>
    </template>
    <template slot-scope="{ row }" slot="piaoMoney">
      <div class="c333 f13">大于{{ row.piaoMoney }}</div>
      <div class="c999 f12">票面金额</div>
    </template>
    <template slot-scope="{ row }" slot="rate">
      <div class="dp-c-important f19 fb">{{ row.rate }}<span class="dp-c-important f13">%</span></div>
      <div class="c999 f12">贴现年化利率</div>
    </template>
    <!--<template slot-scope="{ row }" slot="icon">
      <Icon type="ios-arrow-forward" class="cB5B5B5 f12" />
    </template>-->
  </Table>
</template>

<script>
import store from '@/store/store';
export default {
  store, // 引用
  name: "tableMenu",
  data () {
    return {
      tableParam: {
        header: false, // 是否展示表头
        size: "large", // 表格尺寸
        columns: [
          {
            title: '',
            slot: 'bankName'
          },
          {
            title: '',
            slot: 'bankType'
          },
          {
            title: '',
            slot: 'piaoMoney'
          },
          {
            title: '',
            slot: 'rate'
          }
          /*{
            title: '',
            slot: 'icon',
            align: 'right',
            width: "40"
          }*/
        ],
        data: [
          /*{
            bankName: '重庆富民银行',
            bankType: "一类国股银行",
            piaoMoney: '500万',
            rate: "3.55",
            bankIcon: "fm"
          }*/
        ]
      }
    }
  },
  methods: {
    // 初始化银行报价列表
    initBankQuoteList () {
      this.sendGet({
        url: '/web/discountPlatform/bankQuote'
      }, (result) => {
        if (!result.data.data) {
          this.$Message.info('未查询到今日贴现银行报价信息');
        } else {
          let quoteList = JSON.parse(this.HTMLDecode(result.data.data.bankQuoteJson)).data;
          this.tableParam.data = [];
          for (let i in quoteList) {
            if (quoteList[i].mtBank == "FM") {
              // 富民
              this.tableParam.data.push({
                bankName: '重庆富民银行',
                bankType: quoteList[i].body[2].bodyHead[0],
                piaoMoney: quoteList[i].body[2].bodyHead[1],
                rate: this.formatMoney(Number(quoteList[i].body[2].tableCells[1].discountRate).mul(100), 2, ''),
                bankIcon: "FM"
              });
              this.tableParam.data.push({
                bankName: '重庆富民银行',
                bankType: quoteList[i].body[5].bodyHead[0],
                piaoMoney: quoteList[i].body[5].bodyHead[1],
                rate: this.formatMoney(Number(quoteList[i].body[5].tableCells[1].discountRate).mul(100), 2, ''),
                bankIcon: "FM"
              });
            } else if (quoteList[i].mtBank == "WHLH") {
              console.log(quoteList[i].body[1].tableCells[1], '======11111111111===')
              // 蓝海
              this.tableParam.data.push({
                bankName: '蓝海银行',
                bankType: quoteList[i].body[1].bodyHead[0],
                piaoMoney: quoteList[i].body[1].bodyHead[1],
                rate: this.formatMoney(Number(quoteList[i].body[1].tableCells[1].discountRate).mul(100), 2, ''),
                bankIcon: "WHLH"
              });
              this.tableParam.data.push({
                bankName: '蓝海银行',
                bankType: quoteList[i].body[5].bodyHead[0],
                piaoMoney: quoteList[i].body[5].bodyHead[1],
                rate: this.formatMoney(Number(quoteList[i].body[5].tableCells[1].discountRate).mul(100), 2, ''),
                bankIcon: "WHLH"
              });
            } else if (quoteList[i].mtBank == "YNHT") {
              // 红塔
              this.tableParam.data.push({
                bankName: '云南红塔银行',
                bankType: quoteList[i].body[9].bodyHead[0],
                piaoMoney: quoteList[i].body[9].bodyHead[1],
                rate: this.formatMoney(Number(quoteList[i].body[9].tableCells[0].discountRate).mul(100), 2, ''),
                bankIcon: "YNHT"
              });
            }
          }

        }
        // console.log("获取银行报价", this.quoteList);
      })
    }
  },
  created () {
    // console.log("teshd", this.$store.state.menuList)
    // 初始化银行报价列表
    this.initBankQuoteList();
  },
}
</script>



// WEBPACK FOOTER //
// src/components/module/Table.vue